import { RefObject, useEffect } from 'react';
import { EGlobalClassnames } from 'constants/dom/global-classnames';

export const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  handler: (event: MouseEvent | TouchEvent) => void,
  skipAnt?: {
    imagePreview?: boolean;
    tooltip?: boolean;
  }
) => {
  const skipAntImagePreview = skipAnt?.imagePreview || true;
  const skipAntTooltip = skipAnt?.tooltip || true;

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const antImagePreview = document.querySelector('.ant-image-preview-wrap');
      const antImagePreviewControls = document.querySelector(
        '.ant-image-preview-operations-wrapper'
      );
      const antTooltip = document.querySelector('.ant-tooltip');
      const confirmPopup = document.querySelector(
        `.${EGlobalClassnames.ConfirmPopup}`
      );
      const xModals = document.querySelectorAll(`.${EGlobalClassnames.Modal}`);
      const selectListOptions = document.querySelector('.ant-select-dropdown');
      switch (true) {
        // won't fire if clicked on ant image preview
        case skipAntImagePreview &&
          (antImagePreview?.contains(event.target as Node) ||
            antImagePreviewControls?.contains(event.target as Node)):
        case skipAntTooltip && antTooltip?.contains(event.target as Node): // won't fire if clicked on ant tooltip
        case confirmPopup && confirmPopup?.contains(event.target as Node): // won't fire if clicked on confirm popup
        case xModals &&
          Array.from(xModals).some(modal =>
            modal.contains(event.target as Node)
          ): // won't fire if clicked on modal
        case ref.current && ref.current.contains(event.target as Node): // won't fire if clicked inside component
        case selectListOptions?.contains(event.target as Node):
          break;
        default:
          handler(event);
          break;
      }
    };
    document.addEventListener('mouseup', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mouseup', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, skipAntImagePreview, skipAntTooltip]);
};
